export default __webpack_public_path__ + "static/gorm-e65eeceb2d4efbfd370fb04135505eba.svg";